/**
 * @fileoverview Layout Sabitleri
 *
 * UI bilesenleri icin boyut degerleri (piksel cinsinden).
 *
 * @module utils/constants/layout
 */

/**
 * Layout boyut sabitleri.
 * Tum degerler piksel cinsindendir.
 *
 * @constant {Object}
 * @property {number} CARD_WIDTH - Ilan karti genisligi
 * @property {number} CARD_GAP - Kartlar arasi bosluk
 * @property {number} CARD_IMAGE_SIZE - Kart ici resim boyutu
 * @property {number} DETAIL_PANEL_WIDTH - Ilan detay paneli genisligi
 * @property {number} LEFT_PANEL_WIDTH - Sol panel (liste) genisligi
 * @property {number} COMPOSER_OFFSET - ChatGPT composer offset degeri
 * @property {number} MAP_HEIGHT_INLINE - Inline modda harita yuksekligi
 * @property {number} MAP_HEIGHT_INLINE_SM - Kucuk ekranda inline harita yuksekligi
 */
export const LAYOUT = {
  CARD_WIDTH: 280,
  CARD_GAP: 12,
  CARD_IMAGE_SIZE: 96,
  DETAIL_PANEL_WIDTH: 360,
  LEFT_PANEL_WIDTH: 420,
  COMPOSER_OFFSET: 100,
  MAP_HEIGHT_INLINE: 400,
  MAP_HEIGHT_INLINE_SM: 500,
};
